import { render, staticRenderFns } from "./UsuariosPos.vue?vue&type=template&id=5b0b389e&"
import script from "./UsuariosPos.vue?vue&type=script&lang=js&"
export * from "./UsuariosPos.vue?vue&type=script&lang=js&"
import style0 from "./UsuariosPos.vue?vue&type=style&index=0&id=5b0b389e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports